const pad2 = (n: number): string => (n < 10 ? `0${n}` : `${n}`);

export function formatDate(value: Date, showTime = false): string {
  if (Number.isNaN(value.getTime())) {
    return "";
  }

  const dateStr = `${formatYear(value.getFullYear())}-${pad2(
    value.getMonth() + 1
  )}-${pad2(value.getDate())}`;

  if (!showTime) {
    return dateStr;
  }

  return `${dateStr}T${pad2(value.getHours())}:${pad2(value.getMinutes())}`;
}

export function formatYear(year: number): string {
  if (year < 10) return `000${year}`;
  if (year < 100) return `00${year}`;
  if (year < 1000) return `0${year}`;
  return `${year}`;
}
